import { z } from "zod";
import { isoDateOnlySchema } from "../common/date.js";
import { phoneSchema } from "../common/phone.js";
export const createBookingSchema = z
    .object({
    property_id: z.uuid(),
    start_date: isoDateOnlySchema,
    end_date: isoDateOnlySchema,
    num_guests: z.number().int().min(1),
    num_adults: z.number().int().min(0).optional(),
    num_children: z.number().int().min(0).optional(),
    num_infants: z.number().int().min(0).optional(),
    pet_count: z.number().int().min(0).optional(),
    includes_linens: z.boolean().optional(),
    includes_towels: z.boolean().optional(),
    security_deposit: z.number().int().min(0),
    notes: z.string().max(2000).optional(),
    tenant_email: z.email().toLowerCase().trim(),
    tenant_first_name: z.string().min(1).max(100).optional(),
    tenant_last_name: z.string().min(1).max(100).optional(),
    tenant_phone: phoneSchema,
    tenant_address: z.string().max(500).optional(),
    force: z.boolean().optional(),
})
    .refine((data) => (data.num_adults ?? 0) + (data.num_children ?? 0) + (data.num_infants ?? 0) === data.num_guests, {
    message: "La somme des adultes, enfants et bebes doit etre egale au nombre de voyageurs.",
    path: ["num_guests"],
});
